import axios from "axios";

const api = axios.create({
    baseURL: "https://sms.jaigurujewellers.com", // 🔥 change here only
    headers: {
        "Content-Type": "application/json",
    },
});

export default api;